/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Paper,
  Stack,
  Typography,
  IconButton,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableCell,
  TableBody
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import deleteIcon from '@iconify/icons-ic/round-delete-outline';
import editIcon from '@iconify/icons-eva/edit-fill';
import useSettings from 'src/hooks/useSettings';
import { useSelector } from 'react-redux';
import { COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD } from 'src/constants/Dashboard';
import CollectionRuleDialog from './CollectionRuleDialog';

// ----------------------------------------------------------------------

ExclusionRuleList.propTypes = {
  selectedExclusionRuleId: PropTypes.number,
  setExclusionRule: PropTypes.func,
  exclusionRule: PropTypes.array
};

export default function ExclusionRuleList({ selectedExclusionRuleId, setExclusionRules, exclusionRules }) {
  const { themeStretch } = useSettings();
  const { particularExclusionRuleData } = useSelector((state) => state.exclusionrules);
  let indexNumber = 0;

  useEffect(() => {
    setExclusionRules(
      particularExclusionRuleData[selectedExclusionRuleId]
        ? particularExclusionRuleData[selectedExclusionRuleId]?.rules
        : []
    );
  }, [selectedExclusionRuleId, particularExclusionRuleData]);

  const handleRuleDelete = (e, exclusionRulesIndex) => {
    const tempSegmentRules = [...exclusionRules];
    tempSegmentRules.splice(exclusionRulesIndex, 1);
    setExclusionRules(tempSegmentRules);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      <Paper>
        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-evenly">
          <TableContainer>
            <Table
              size="small"
              aria-label="purchases"
              //
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.length}
                    sx={{
                      background: 'blanchedalmond',
                      boxShadow: 'inset -8px 0 0 blanchedalmond !important;',
                      fontSize: '16px'
                    }}
                  >
                    Rule List
                  </TableCell>
                </TableRow>
                {/* Collapsable Table Head Row */}
                <TableRow>
                  {COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.map((headData) => (
                    <TableCell
                      sx={{
                        boxShadow: headData.id === 'no' || headData.id === 'action' ? 'none !important' : ''
                      }}
                      align={headData.align ? headData.align : 'center'}
                      key={headData.key}
                    >
                      {headData.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {exclusionRules && exclusionRules?.length !== 0 ? (
                <TableBody sx={{ background: 'white' }}>
                  {exclusionRules?.length !== 0 &&
                    exclusionRules?.map((nestedRowData, exclusionRulesIndex) => (
                      <>
                        {/* findInnerRuleLength */}
                        {exclusionRulesIndex !== 0 && nestedRowData.rules.length !== 0 && (
                          <TableRow key={exclusionRulesIndex + 1}>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                              colSpan="5"
                              sx={{ fontWeight: 'bolder' }}
                            >
                              AND
                            </TableCell>
                          </TableRow>
                        )}
                        {nestedRowData?.rules.map((innerNestedRules, index) => {
                          indexNumber += 1;
                          return (
                            <>
                              {index !== 0 && (
                                <TableRow key={exclusionRulesIndex} sx={{ background: 'aliceblue' }}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="center"
                                    colSpan="5"
                                    sx={{ fontWeight: 'bolder' }}
                                  >
                                    OR
                                  </TableCell>
                                </TableRow>
                              )}
                              <TableRow key={innerNestedRules.id} sx={{ background: 'aliceblue' }}>
                                <TableCell>{indexNumber}</TableCell>
                                <TableCell>{innerNestedRules.column_name}</TableCell>
                                <TableCell align="center">{innerNestedRules.if_cell_value}</TableCell>
                                <TableCell align="center">{innerNestedRules.value_or_text}</TableCell>
                                <TableCell align="center">
                                  {index === 0 && (
                                    <>
                                      <CollectionRuleDialog
                                        dialogTitle="Edit Filtering Rule"
                                        icon={editIcon}
                                        showbtnIcon
                                        parentRuleId={exclusionRulesIndex}
                                        editId={{
                                          ruleId: nestedRowData.rule_collection_id,
                                          data: nestedRowData?.rules
                                        }}
                                        setExclusionRules={setExclusionRules}
                                      />
                                      <IconButton
                                        size="small"
                                        title="Delete"
                                        onClick={(e) => {
                                          handleRuleDelete(e, exclusionRulesIndex);
                                        }}
                                      >
                                        <Icon icon={deleteIcon} />
                                      </IconButton>
                                    </>
                                  )}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </>
                    ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.length + 1} align="center">
                      <Typography gutterBottom align="center" variant="subtitle1">
                        No Data Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Stack>
      </Paper>
    </Container>
  );
}
